import { createContext, useCallback, useContext } from "react";
import { useSettings } from "@/modules/settings";

type SidebarContextValue = {
  isOpen: boolean;
  toggle: () => void;
  close: () => void;
  open: () => void;
};

const SidebarContext = createContext<SidebarContextValue | null>(null);

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const { sidebarOpen, setSidebarOpen } = useSettings();

  const toggle = useCallback(
    () => setSidebarOpen(!sidebarOpen),
    [sidebarOpen, setSidebarOpen]
  );
  const close = useCallback(() => setSidebarOpen(false), [setSidebarOpen]);
  const open = useCallback(() => setSidebarOpen(true), [setSidebarOpen]);

  return (
    <SidebarContext.Provider
      value={{ isOpen: sidebarOpen, toggle, close, open }}
    >
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within SidebarProvider");
  }
  return context;
}
